import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _ERROR_SYMBOLS$INFO;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _ from 'lodash';
var ERROR_SYMBOLS = {
  INFO: Symbol(),
  OPTIONS: Symbol()
};

var DEFAULT_ADAPTER = function DEFAULT_ADAPTER(_ref, _ref2) {
  var code = _ref.code,
      _ref$message = _ref.message,
      message = _ref$message === void 0 ? '' : _ref$message,
      _ref$params = _ref.params,
      params = _ref$params === void 0 ? {} : _ref$params;
  var ft = _ref2.ft;
  return _.chain(["Error[".concat(code, "]"), (params.field && ft ? "(".concat(ft('fields.' + params.field), "): ") : '') + Object.keys(params).reduce(function (result, key) {
    return result.replace(new RegExp("{{2}s{0,}".concat(key, "s{0,}}{2}")), params[key]);
  }, message || '')]).without('').join(' - ').value();
};

_ERROR_SYMBOLS$INFO = ERROR_SYMBOLS.INFO;

var GuiError = /*#__PURE__*/function (_Error) {
  _inherits(GuiError, _Error);

  var _super = _createSuper(GuiError);

  function GuiError(errors) {
    var _this;

    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref3$et = _ref3.et,
        et = _ref3$et === void 0 ? GuiError.OVERRIDE_ET : _ref3$et,
        ft = _ref3.ft;

    _classCallCheck(this, GuiError);

    var err = _.values(_.keyBy(_.isArray(errors) ? errors : _.isObject(errors) ? [errors] : _.isString(errors) ? [{
      code: -1,
      message: errors,
      params: {}
    }] : null, 'code'));

    var msg = GuiError.getMessage(err, {
      et: et,
      ft: ft
    });
    _this = _super.call(this, msg);

    _defineProperty(_assertThisInitialized(_this), _ERROR_SYMBOLS$INFO, []);

    _this[ERROR_SYMBOLS.INFO] = {
      errors: err,
      msg: msg
    };
    _this[ERROR_SYMBOLS.OPTIONS] = {
      et: et,
      ft: ft
    };
    Object.defineProperty(_assertThisInitialized(_this), 'codes', {
      get: function get() {
        return _this[ERROR_SYMBOLS.INFO].errors.map(function (_ref4) {
          var _ref4$code = _ref4.code,
              code = _ref4$code === void 0 ? -1 : _ref4$code;
          return code;
        });
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), 'code', {
      get: function get() {
        return _this.codes[0] || null;
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), 'message', {
      get: function get() {
        return _this[ERROR_SYMBOLS.INFO].msg;
      }
    });
    return _this;
  }

  _createClass(GuiError, [{
    key: "hasCode",
    value: function hasCode(code) {
      return this[ERROR_SYMBOLS.INFO].errors.findIndex(function (_ref5) {
        var _ref5$code = _ref5.code,
            $code = _ref5$code === void 0 ? -1 : _ref5$code;
        return $code === code;
      }) >= 0;
    }
  }, {
    key: "setMessage",
    value: function setMessage(msg) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var errors = this[ERROR_SYMBOLS.INFO].errors;
      var _this$ERROR_SYMBOLS$O = this[ERROR_SYMBOLS.OPTIONS],
          et = _this$ERROR_SYMBOLS$O.et,
          ft = _this$ERROR_SYMBOLS$O.ft;
      var targets = _.isArray(msg) ? msg : _.isObject(msg) ? [msg] : [{
        code: -1,
        message: msg
      }];

      var targetMap = _.keyBy(targets, 'code');

      this[ERROR_SYMBOLS.INFO] = {
        msg: GuiError.getMessage(targets, {
          et: et,
          ft: ft,
          params: _.merge(this[ERROR_SYMBOLS.OPTIONS].params, params)
        }),
        errors: errors.map(function (_ref6) {
          var _ref6$code = _ref6.code,
              code = _ref6$code === void 0 ? -1 : _ref6$code,
              message = _ref6.message;
          return !_.has(targetMap, code) ? {
            code: code,
            message: message
          } : {
            code: code,
            message: targetMap[code].message
          };
        })
      };
      return this.message;
    }
  }], [{
    key: "getMessage",
    value: function getMessage(errors, _ref7) {
      var _ref7$et = _ref7.et,
          et = _ref7$et === void 0 ? GuiError.OVERRIDE_ET : _ref7$et,
          ft = _ref7.ft;
      return !errors || errors.length === 0 ? null : errors.map(function (err) {
        return GuiError.OVERRIDE_ET(err, {
          ft: ft
        }) || DEFAULT_ADAPTER(err, {
          ft: ft
        });
      }).join('');
    }
  }]);

  return GuiError;
}( /*#__PURE__*/_wrapNativeSuper(Error)); // export getSystemMsg
// export getMsg
// export getInstance
// export createInstance
// export default


_defineProperty(GuiError, "OVERRIDE_ET", function () {
  return null;
});

export { GuiError as default };